import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetFacilitiesOptionsResponseDtoSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  })
);

export type GetFacilitiesOptionsResponseDto = z.infer<
  typeof GetFacilitiesOptionsResponseDtoSchema
>;

export const getFacilitiesOptions = (config?: AxiosRequestConfig) => {
  return api
    .get('/facilities/options', config)
    .then(responseContract(GetFacilitiesOptionsResponseDtoSchema));
};
